var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "chat-separator w-100" },
    [
      _c("a-divider", { staticClass: "_divider" }, [
        _vm._v(_vm._s(_vm.time())),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "desc" }, [
        _vm._v(_vm._s(_vm.$t("message.createdDate"))),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }